import { Component } from '@angular/core';
import { ListService } from '@abp/ng.core';
import { CardBodyComponent, CardComponent, ConfirmationService } from '@abp/ng.theme.shared';
import { CrudPage } from '@zendra/shared';
import { GetGisStandInconsistenciesInputDto, GisStandInconsistencyCase } from 'orchestrator';
import { GisStandInconsistencyBase } from '../gis-stand-inconsistency/gis-stand-inconsistency-base';
import {
  GISSTANDINCONSISTENCYONLYINGIS_CONFIG,
  GISSTANDINCONSISTENCYONLYINGIS_FIELDS,
} from './gis-stand-inconsistency-only-in-gis.config';

@Component({
  selector: 'app-gis-stand-inconsistency-only-in-gis',
  imports: [CardComponent, CardBodyComponent, CrudPage],
  providers: [ListService, ConfirmationService],
  templateUrl: '../gis-stand-inconsistency/gis-stand-inconsistency.html',
})
export class GisStandInconsistencyOnlyInGis extends GisStandInconsistencyBase {
  config = GISSTANDINCONSISTENCYONLYINGIS_CONFIG;
  fields = GISSTANDINCONSISTENCYONLYINGIS_FIELDS;

  protected override get caseFilter(): Partial<GetGisStandInconsistenciesInputDto> {
    return { case: GisStandInconsistencyCase.OnlyInGis };
  }

  protected getEntityName(): string {
    return 'GisStandInconsistencyOnlyInGis';
  }
}